import './_gallery.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';

export default function Gallery() {
    const galleries = document.querySelectorAll<HTMLElement>('.gallery');
    if (!galleries.length) return;

    galleries.forEach((item, index) => {
        const swiperContainer = item.querySelector('.swiper') as HTMLElement;
        const slides = swiperContainer.querySelectorAll('.swiper-slide');

        swiperContainer.setAttribute('id', `swiper-gallery-${index}`);

        const swiperBtnNext = item.querySelector('.swiper-button-next') as HTMLElement;
        const swiperBtnPrev = item.querySelector('.swiper-button-prev') as HTMLElement;
        const swiperPagination = item.querySelector('.swiper-pagination') as HTMLElement;

        // ── Swiper ────────────────────────────────────────────────────────────
        if (slides.length === 1) swiperContainer.classList.add('one-slide');
        else if (slides.length === 2) swiperContainer.classList.add('two-slides');
        else if (slides.length === 3) swiperContainer.classList.add('three-slides');

        const swiper = new Swiper(swiperContainer, {
            modules: [Navigation, Pagination],
            pagination: { el: swiperPagination, clickable: true },
            // centeredSlides: slides.length === 2 ? false : slides.length > 2,
            centeredSlides: false,
            //loop: slides.length > 3,
            loop: false,
            navigation: { nextEl: swiperBtnNext, prevEl: swiperBtnPrev, addIcons: false },
            breakpoints: {
                0: { spaceBetween: 12, slidesPerView: slides.length === 1 ? 1 : 1.5 },
                768: { spaceBetween: 28, slidesPerView: slides.length <= 3 ? 1.5 : 2 },
                1400: { spaceBetween: 28, slidesPerView: slides.length <= 3 ? 'auto' : 2 },
            },
            on: {
                afterInit() {
                    swiperPagination.querySelectorAll<HTMLElement>('.swiper-pagination-bullet').forEach(b => {
                        b.setAttribute('tabindex', '0');
                        b.addEventListener('keydown', (e: KeyboardEvent) => {
                            if (e.key === 'ArrowLeft') swiper.slidePrev();
                            if (e.key === 'ArrowRight') swiper.slideNext();
                        });
                    });
                },
                slideChange() {
                    swiperPagination.querySelector<HTMLElement>('.swiper-pagination-bullet-active')?.focus();
                },
            },
        });

        swiperBtnNext?.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.code === 'Enter') swiper.slideNext();
        });
        swiperBtnPrev?.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.code === 'Enter') swiper.slidePrev();
        });

        swiper.init();

        // ── GLightbox per ogni gallery (gruppo isolato) ──────────────────────
        const firstLink = item.querySelector<HTMLAnchorElement>('.swiper-slide a[data-gallery]');
        const galleryId = firstLink?.dataset.gallery ?? `gallery-${index}`;

        GLightbox({
            selector: `[data-gallery="${galleryId}"]`,
            touchNavigation: true,
            keyboardNavigation: true,
            loop: false,
            autoplayVideos: true,
        });
    });
}
